export default __webpack_public_path__ + "static/media/iHR02.accd423d.png";